<template>
    <p>One of my biggest passions is building software. From designing the system and coding the logic, to launching the polished product.</p>
    <p>I am now available for hire. Whether you need consulting on your latest project, or a full build from start to finish, I'm here to help.</p>
    <p>Some things I specialize in:</p>
    <ul>
        <li>Project Organization & Maintainability</li>
        <li>Full Stack Web Development</li>
        <li>Backend Rest Applications</li>
        <li>Single Page Web Applications</li>
        <li>Multi Page Web Applications</li>
        <li>Data Visualization</li>
        <li>Building Machine Learning Models</li>
        <li>Deploying Machine Learning Models</li>
    </ul>
    <p><strong><router-link to="/#about">Ready to get started? Let's talk.</router-link></strong></p>
</template>

<script>
    export default {
        name: "FreelanceTimeline",
        components: {

        },
        data () {
            return {

            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style scoped lang="scss">
    @import '~@/assets/variables';

    a {
        color: inherit;
    }
    strong {
        color: $green;
    }

    li {
        margin-bottom: $reading-line-height/2;
    }
</style>